/**
 * Inline error + retry shown when a services-tier scope fetch (customer or
 * plant) fails, so a failed fetch degrades to a recoverable message instead
 * of a bare title over an empty page.
 *
 * Contains:
 * - FetchErrorState — presentational error + retry component
 */
import { Alert, Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @param {{ message: string, onRetry: () => void }} props
 *   message — the error text to show.
 *   onRetry — re-triggers the failed fetch.
 */
function FetchErrorState({ message, onRetry }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
      <Alert
        severity="error"
        sx={{ maxWidth: 480 }}
        action={
          <Button size="small" color="inherit" onClick={onRetry}>
            {t('actions.retry', 'Retry')}
          </Button>
        }
      >
        {message}
      </Alert>
    </Box>
  );
}

export default FetchErrorState;
